import React from "react";
import Card from "../../component/Card";
import "./style.scss";
import VariableQuotaLedgerTable from "../../component/VariableQuotaLedgerTable";

const VariableQuotaLedger: React.FC = () => {
	
	return (
		<div className="home-wrapper table-layout">
			<div className="mailchimp-table-wrapper">
				<VariableQuotaLedgerTable />
			</div>
		</div>
	);
};

export default VariableQuotaLedger;
